<script setup>
import { OneBoxDefault } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src'

const props = defineProps({
  breadCrumbList: {
    type: Array,
    default: () => [{ text: '全国' }]
  },
  area: {
    type: String,
    default: ''
  },
  areaRoma: {
    type: String,
    default: ''
  },
  pref: {
    type: String,
    default: ''
  },
  prefRoma: {
    type: String,
    default: ''
  }
})
const { $ads } = useNuxtApp()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const runtimeConfig = useRuntimeConfig()
const EnvDevDomains = runtimeConfig.public.devDomains
const devDomains = EnvDevDomains ? JSON.parse(EnvDevDomains) : null
useCustomJsonld(props.breadCrumbList)
const amedasProps = computed(() => {
  if (props.area && props.areaRoma) {
    return {
      'amedas-area': props.area,
      'amedas-area-roma': props.areaRoma
    }
  } else if (props.pref && props.prefRoma) {
    return {
      'amedas-pref': props.pref,
      'amedas-pref-roma': props.prefRoma
    }
  } else {
    return {}
  }
})
onMounted(() => {
  $ads.init(adsConfig)
})
</script>

<template>
  <div>
    <OneBoxDefault
      :bread-crumb-list="breadCrumbList"
      :dev-domains="devDomains"
      v-bind="amedasProps"
    >
      <slot />
      <template #ads-atf>
        <div
          v-if="!isWebViewFlag"
          id="ads-atf-pc"
          class="ads-atf-pc"
        />
        <div
          v-if="!isWebViewFlag"
          id="ads-atf-sp"
          class="ads-atf-sp"
        />
      </template>
      <template #main-bottom>
        <slot name="main-bottom" />
      </template>
      <template #ads-btf3>
        <div
          v-if="!isWebViewFlag"
          id="ads-btf3-pc"
          class="ads-btf3-pc"
        />
        <div
          v-if="!isWebViewFlag"
          id="ads-btf3-sp"
          class="ads-btf3-sp"
        />
      </template>
    </OneBoxDefault>
    <StickyAd />
  </div>
</template>

<style>
html {
  scroll-behavior: unset;
}
</style>

<style scoped>
.ads-atf-pc {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}
.ads-atf-sp {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}
.ads-btf3-pc {
  min-height: 50px;
  margin: 15px auto 5px;
}

.ads-btf3-sp {
  min-height: 50px;
  margin: 15px auto 5px;
}
</style>
